import { Controller } from "@hotwired/stimulus"
import { i18n } from "../lib/i18n"

export default class extends Controller {
  static targets = ["collapseIcon", "expandIcon", "buttonText", "expandableContent", "collapseTitle"]
  static values = {
    expandAll: Boolean,
    toggled: Boolean
  }

  declare collapseIconTarget: HTMLElement
  declare expandIconTarget: HTMLElement
  declare buttonTextTarget: HTMLElement
  declare expandableContentTargets: HTMLElement[]
  declare collapseTitleTargets: HTMLElement[]
  declare expandAllValue: boolean
  declare toggledValue: boolean

  // Rows keep the server's open state (search results arrive open) until the
  // user picks Expand all / Collapse all; from then on, rows appended later
  // (infinite scroll) follow that choice, until a new search or filter replaces
  // the list (resetToggle). The choice lives in data attributes, so a page
  // restored from the Turbo cache keeps it.
  connect() {
    this.updateButton()
  }


  toggleExpandAll() {
    this.toggledValue = true
    this.expandAllValue = !this.expandAllValue
    this.updateUI()
  }

  resetToggle() {
    this.toggledValue = false
  }

  expandableContentTargetConnected(content: HTMLElement) {
    if (this.toggledValue) content.classList.toggle('collapse-open', this.expandAllValue)
  }

  toggleExpand(event: Event) {
    const clickedTitle = event.currentTarget as HTMLElement
    const content = clickedTitle.closest('[data-expanding-target="expandableContent"]')
    
    if (content) {
      content.classList.toggle('collapse-open')
    }
  }

  private updateUI() {
    this.updateButton()
    this.expandableContentTargets.forEach(content => {
      content.classList.toggle('collapse-open', this.expandAllValue)
    })
  }

  private updateButton() {
    this.collapseIconTarget.classList.toggle('hidden', !this.expandAllValue)
    this.expandIconTarget.classList.toggle('hidden', this.expandAllValue)
    this.buttonTextTarget.textContent = i18n.t(this.expandAllValue ? 'expanding.collapse_all' : 'expanding.expand_all')
  }
}